import React, { useState, useMemo, useEffect } from "react";
import StickyCountdown from "@/components/site/StickyCountdown";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import TrustMarquee from "@/components/site/TrustMarquee";
import Pricing from "@/components/site/Pricing";
import FreeGifts from "@/components/site/FreeGifts";
import About from "@/components/site/About";
import Ingredients from "@/components/site/Ingredients";
import Benefits from "@/components/site/Benefits";
import HowItWorks from "@/components/site/HowItWorks";
import Reviews from "@/components/site/Reviews";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import StickyBuyBar from "@/components/site/StickyBuyBar";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import PurchaseModal from "@/components/site/PurchaseModal";
import { getVariant } from "@/lib/variants";
import { captureUTM } from "@/lib/utm";

const BOTTLE_URL =
  "https://i.postimg.cc/wj8DQLK6/328dbd91-46f8-45fc-8e9e-e5d37b41ad69.jpg";

export default function Landing() {
  const [modalOpen, setModalOpen] = useState(false);
  const [preMethod, setPreMethod] = useState(null);
  const variant = useMemo(() => getVariant(), []);

  useEffect(() => { captureUTM(); }, []);

  const openModal = (method = null) => {
    setPreMethod(method);
    setModalOpen(true);
  };

  return (
    <div
      className="relative min-h-screen bg-black text-white"
      data-variant={variant.id}
    >
      <StickyCountdown />
      <Hero
        onBuy={() => openModal()}
        bottleUrl={BOTTLE_URL}
        variant={variant}
      />
      <TrustStrip />
      <TrustMarquee />
      <Pricing
        onBuyPrepaid={() => openModal("prepaid")}
        onBuyCod={() => openModal("cod")}
      />
      <FreeGifts onBuy={() => openModal()} />
      <About />
      <Ingredients />
      <Benefits />
      <HowItWorks />
      <Reviews />
      <FAQ />
      <FinalCTA onBuy={() => openModal()} />
      <Footer />

      <WhatsAppButton phone="918817725280" />
      <StickyBuyBar onClick={() => openModal()} />
      <PurchaseModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        initialMethod={preMethod}
      />
      <div className="h-24" aria-hidden="true" />
    </div>
  );
}
